// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Feed-cls1__b6f0b7be09e44bb6568c{/*!*/}.Feed-cls2___7c451b881a1cc1074a8{display:flex;align-items:center;justify-content:center;padding-top:12px;font-weight:bold;grid-gap:8px;gap:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Feed-cls1__b6f0b7be09e44bb6568c",
	"cls2": "Feed-cls2___7c451b881a1cc1074a8 Feed-cls1__b6f0b7be09e44bb6568c"
};
export default ___CSS_LOADER_EXPORT___;
